import classnames from 'classnames';
import { TRANSPORT_PROVIDER_ABBR } from '@lp/features/RoutePlanner/utils';
import { RouteLegTypeEnum } from '@/api/apis/route';

type TransportTypeProps = {
  legType: RouteLegTypeEnum;
  bgColor?: string;
};

export const TransportType = ({ legType, bgColor = 'bg-black' }: TransportTypeProps) => {
  const transportType = TRANSPORT_PROVIDER_ABBR[legType];

  if (!transportType) return null;

  return (
    <span
      className={classnames('px-1 py-0.5 text-xs-m text-white flex justify-center items-center rounded-full', bgColor)}
    >
      {transportType}
    </span>
  );
};
